import React from "react";
import { useTranslation } from "react-i18next";
import { GoalArrowCircleIcon } from "@/apps/goals/assets/icons";
import Button from "@/ui/Button/Button";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import cls from "./styles.module.scss";

export const GoToParkButton = () => {
  const { t } = useTranslation();
  const initData = useGoalsStore((state) => state.initData);
  const parkKey = initData?.tariff === 'Еда' ? 'goals.common.edaPark' : 'goals.common.taxiPark';
  const fallbackLink = initData?.tariff === 'Еда' ? 'https://t.me/EdaBkchat' : 'https://t.me/BogatiyTaksist_chat';
  const link = initData?.program.invite_chat_url ?? fallbackLink;

  return (
    <Button
      className={cls.button}
      icon={<GoalArrowCircleIcon />}
      iconClassName={cls.icon}
      iconPosition="right"
      label={t(parkKey)}
      variant="graphite"
      split
      onClick={() => window.open(link)}
    />
  );
};
